import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import "./PackageForm.css"
const PackageInclude = ({ packageId }) => {
  const initialFieldValues = {
    packageIncludeId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    description: "",
  };
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [data, setData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [newItemDesc, setNewItemDesc] = useState(""); 
  const [editingId, setEditingId] = useState(null); 
  const [editingText, setEditingText] = useState(""); 

   const handleAddNewSubmit = async (e) => {
    e.preventDefault();
    if (newItemDesc.trim() === "") return;
    
    const formData = { ...initialFieldValues, description: newItemDesc, packageId, userId: user?.id };
    await apiService.create(config.CREATEPACKAGEINCLUDE, formData);
    await GetData();
    setNewItemDesc(""); 
  };
  
  const handleUpdateSubmit = async (id) => {
    if (editingText.trim() === "") return;
    
    const formData = { packageIncludeId: id, description: editingText, packageId, userId: user?.id };
    await apiService.update(config.UPDATEPACKAGEINCLUDE, formData);
    await GetData();
    setEditingId(null); 
    setEditingText("");
  };

  const startEditing = (item) => {
    setEditingId(item.packageIncludeId);
    setEditingText(item.description);
  };
  
  const cancelEditing = () => {
    setEditingId(null);
    setEditingText("");
  };


  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async () => {
    const res = await apiService.get(
      `${config.GETINCLUDEBYPACKAGEID}/${packageId}`
    );
    console.log(res);
    setLists(res.data);
    setData(res.data);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGEINCLUDE, itemToDelete);
        await GetData();
      } catch (error) {
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.description = values.description === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageIncludeId: values.packageIncludeId,
        packageId: packageId,
        description: values.description,
        userId: user?.id,
      };
      console.log("Submitting form data:", formData);
      try {
        const isNew =
          formData.packageIncludeId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGEINCLUDE, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGEINCLUDE, formData);
        }
        await GetData();
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setRecordForEdit(null);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

   useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);
  
  return (
   <div className="PackageInclude-wrapper">
  <div className="PackageInclude-card">
    <div className="PackageInclude-header">
      <h4 className="header-title">Inclusions</h4>
      <p className="header-subtitle">Add or edit package inclusions below</p>
    </div>

    <div className="PackageInclude-list">
      {lists.length > 0 ? (
        lists.map((item) => (
          <div key={item.packageIncludeId} className="PackageInclude-list-item">
            <i className="ri-checkbox-circle-line item-icon" />
            
            {recordForEdit?.packageIncludeId === item.packageIncludeId ? (
              <>
                <input
                  type="text"
                  name="description"
                  value={values.description}
                  onChange={handleInputChange}
                  className="item-edit-input"
                />
                <div className="item-actions">
                  <button
                    className="PackageInclude-action-btn save"
                    onClick={handleSubmit}
                  >
                    <i className="ri-check-line"></i>
                  </button>
                  <button
                    className="PackageInclude-action-btn cancel"
                    onClick={resetForm}
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </div>
              </>
            ) : (
              <>
                <p className="item-description">{item.description}</p>
                <div className="item-actions">
                  <button
                    className="PackageInclude-action-btn edit"
                    onClick={() => showEditDetails(item)}
                  >
                    <i className="ri-pencil-fill"></i>
                  </button>
                  <button
                    className="PackageInclude-action-btn delete"
                    onClick={() => handleOpenDeleteModal(item.packageIncludeId)}
                  >
                    <i className="ri-delete-bin-fill"></i>
                  </button>
                </div>
              </>
            )}
          </div>
        ))
      ) : (
        <div className="PackageInclude-empty-state">
          <i className="ri-inbox-line empty-icon"></i>
          <h5>No inclusions found</h5>
        </div>
      )}
    </div>

    {/* Add New Row */}
    <div className="PackageInclude-list-item mt-3">
      <i className="ri-add-circle-line item-icon"></i>
      <input
        type="text"
        name="description"
        value={recordForEdit === null ? values.description : ""}
        onChange={handleInputChange}
        placeholder="Add a new inclusion..."
        className="form-control"
      />
      <button
        className="PackageInclude-action-btn save"
        onClick={handleSubmit}
      >
        <i className="ri-check-line"></i>
      </button>
    </div>
  </div>

  <DeleteAlert
    show={showDeleteModal}
    handleClose={handleCloseDeleteModal}
    handleDelete={handleDelete}
  />
</div>

  );
};

export default PackageInclude;
